import Stack from '@/design_system/Stack';
import { useArticleName } from '@/models/article';
import { ArticleWithRelations } from '@/models/request';
import { createBEMClasses } from '@/utils/classname';
import useViewPort from '@/utils/useViewport';

import { ClientArticleStepper } from '../../ClientArticleStepper';
import { ArticleNameWithChoice, Choice } from '../components/ArticleNameWithChoice';
import { ClientArticleComment } from '../components/ClientArticleComment';
import { ClientArticleServices } from '../components/ClientArticleServices';
import { DefectsNotToBeRepaired } from '../components/DefectsNotToBeRepaired';

import './ArticleCard.css';

const { block } = createBEMClasses('article-card');

export const ArticleCard = ({
  article,
  showStepper = false,
  showPrice = false,
  showArticleComment = false,
  showChoices = false,
  showArticleServices = false,
  showDefectsNotToBeRepaired = false,
  choice,
  setChoice,
  showChoicesError,
}: {
  article: ArticleWithRelations;
  showStepper?: boolean;
  showPrice?: boolean;
  showArticleComment?: boolean;
  showChoices?: boolean;
  showArticleServices?: boolean;
  showDefectsNotToBeRepaired?: boolean;
  choice?: Choice;
  setChoice?: (choice: Choice) => void;
  showChoicesError?: boolean;
}) => {
  const { isMobile } = useViewPort();

  const articleName = useArticleName({ article });

  return (
    <Stack key={article.id} padding="16px" gap="1rem" className={block()} ariaLabel={articleName}>
      <ArticleNameWithChoice
        article={article}
        showChoices={showChoices}
        choice={choice}
        setChoice={setChoice}
        showChoicesError={showChoicesError}
      />

      {showStepper && (
        <ClientArticleStepper size={isMobile ? 'small' : 'large'} article={article} />
      )}

      {showArticleComment && article.clientComment && (
        <ClientArticleComment comment={article.clientComment} />
      )}

      {showArticleServices && <ClientArticleServices article={article} showPrice={showPrice} />}

      {showDefectsNotToBeRepaired && <DefectsNotToBeRepaired article={article} />}
    </Stack>
  );
};
